export const removeDollarSign = (value: string) => {
  return value.replace(/[$,]/g, '')
}
